<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Reset Password v1 -->
      <b-card class="mb-0">
        <!-- logo -->
        <b-link class="brand-logo">
          <b-img :src="logoUic" />
        </b-link>

        <b-card-title class="mb-1"> Reset Password 🔒 </b-card-title>
        <b-card-text class="mb-2" v-if="!success">
          Your new password must be different from previously used passwords
        </b-card-text>

        <b-card-text class="mb-2" v-else>
          Success reset password please login
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form method="POST" class="auth-reset-password-form mt-2" @submit.prevent="validationForm" v-if="!success">
            <!-- password -->
            <b-form-group label="New Password" label-for="reset-password-new">
              <validation-provider #default="{ errors }" name="Password" vid="Password" rules="required">
                <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                  <b-form-input id="reset-password-new" v-model="password" :type="password1FieldType"
                    :state="errors.length > 0 ? false : null" class="form-control-merge" name="reset-password-new"
                    placeholder="············" />
                  <b-input-group-append is-text>
                    <feather-icon class="cursor-pointer" :icon="password1ToggleIcon" @click="togglePassword1Visibility" />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
                <small id="passwordHelp" class="form-text text-muted">
                  <span :class="
                    has_minimum_lenth && has_lowercase && has_number
                      ? 'text-success'
                      : 'text-danger'
                  ">Password should contain</span>
                  <span :class="has_minimum_lenth ? 'text-success' : 'text-danger'">
                    atleast 8 chacters</span>,
                  <span :class="has_lowercase ? 'text-success' : 'text-danger'">one lowercase letter</span>,
                  <span :class="has_uppercase ? 'text-success' : 'text-danger'">one uppercase letter</span>,
                  <span :class="has_number ? 'text-success' : 'text-danger'">
                    and one number</span>
                </small>
              </validation-provider>
            </b-form-group>

            <!-- confirm password -->
            <b-form-group label-for="reset-password-confirm" label="Confirm Password">
              <validation-provider #default="{ errors }" name="Confirm Password" rules="required|confirmed:Password">
                <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                  <b-form-input id="reset-password-confirm" v-model="password_confirmation" :type="password2FieldType"
                    class="form-control-merge" :state="errors.length > 0 ? false : null" name="reset-password-confirm"
                    placeholder="············" />
                  <b-input-group-append is-text>
                    <feather-icon class="cursor-pointer" :icon="password2ToggleIcon" @click="togglePassword2Visibility" />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button block :type="validatePassword ? 'submit' : 'button'" variant="primary">
              Set New Password
            </b-button>
          </b-form>
        </validation-observer>

        <!-- <p class="text-center mt-2">
            <b-link :to="{ name: 'auth-login-v1' }">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </p> -->
      </b-card>
      <!-- /Reset Password v1 -->
    </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton, BImg,
} from 'bootstrap-vue'
import { required } from '@validations'
import API from '@/api'
import logoUic from '@/assets/images/logo/logo-new-idi.png'
import { validatorPassword } from '@/@core/utils/validations/validators'

export default {
  components: {
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BImg,
  },
  data() {
    return {
      userEmail: '',
      password_confirmation: '',
      password: '',
      // validation
      required,
      success: false,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
      has_minimum_lenth: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,

      logoUic,
    }
  },
  watch: {
    password() {
      this.has_minimum_lenth = (this.password.length >= 8);
      this.has_number = /\d/.test(this.password);
      this.has_lowercase = /[a-z]/.test(this.password);
      this.has_uppercase = /[A-Z]/.test(this.password);

    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    validationForm() {
      console.log(this.validatePassword())
      this.$refs.simpleRules.validate().then(success => {
        if (success && this.validatePassword()) {

          this.submit()
        }
      })


    },
    validatePassword() {
      return this.has_minimum_lenth
    },
    async submit() {

      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        const form = {
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.$route.params.token,
        }
        console.log(form)
        const { data } = await API.auth.changePassword(form)
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
        this.handleMsgSuccess('Successfully change password')
        this.success = true

      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Token tidak valid, silahkan coba lagi!')
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }


    },
  },
}
</script>

<style lang="scss">@import "@core/scss/vue/pages/page-auth.scss";</style>
